import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Homepage from './components/Homepage';
import AboutUs from './components/AboutUs'; // Import other components as needed
import Products from './components/Products'; // Import other components as needed
import ContactUs from './components/ContactUs'; // Import other components as needed
import Careers from './components/Careers'; // Import other components as needed
import Semiconductor from './components/Semiconductor'; // Import other components as needed
import OurProductsSection from './components/OurProductsSection'; // Import other components as needed
import Battery from './components/Battery'; // Import other components as needed
import AutomobilesAndParts from './components/AutomobilesAndParts'; // Import other components as needed
import FoodAndDrink from './components/FoodAndDrink'
import Port from './components/Port'
import Print from './components/Print'
import Packaging from './components/Packaging'
import RubberAndPlastic from './components/RubberAndPlastic'
import InductiveSensor from './components/InductiveSensor'
import PhotoelectricSensors from './components/PhotoelectricSensors'
import CapacitiveSensor from './components/CapacitiveSensor'
import MagneticSensor from './components/MagneticSensor'
import UltrasonicSensor from './components/UltrasonicSensor'
import ColorMarkDetection from './components/ColorMarkDetection'
import VisionSensor from './components/VisionSensor'
import CodeReader from './components/CodeReader'
import AreaObstacleAvoidanceSensor from './components/AreaObstacleAvoidanceSensor'
import NetworkAndConnection from './components/NetworkAndConnection'
import PressureVacuumSensor from './components/PressureVacuumSensor'
import LevelSensor from './components/LevelSensor'
import FlowSensorsFlowMeters from './components/FlowSensorsFlowMeters'
import TemperatureSensors from './components/TemperatureSensors'
import AnalyticalSensors from './components/AnalyticalSensors'
import BTU_HEAT_Meter from './components/BTU_HEAT_Meter'

import Solutions from './components/Solutions'
import ProcessDevice from './components/ProcessDevice'
import EnergyIndustry from './components/EnergyIndustry'
import IndustrialRobots from './components/IndustrialRobots'
import ElectronicsIndustry from './components/ElectronicsIndustry'
import LogisticsIndustry from './components/LogisticsIndustry'
import MedicalTechnology from './components/MedicalTechnology'
import PositionSensor from './components/PositionSensor'
import ProcessFluidSensors from './components/ProcessFluidSensors'
import AiImageRecognition from './components/AiImageRecognition'
import CodeReaderNew from './components/CodeReaderNew'
import TestBox from './components/TestBox'
import ChemicalEngineering from './components/ChemicalEngineering'
import FloatingButton from './components/FloatingButton';
import SafetySensor from './components/SafetySensor';
import CustomCursor from './components/CustomCursor'
import Loder from './components/Loder'; // Loader component
import RouteTitleManager from './components/RouteTitleManager';


const AppRoutes = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(location.pathname === '/');

  useEffect(() => {
    if (location.pathname === '/') {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 2500);
      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [location.pathname]);

  if (loading) return <Loder />;
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/products" element={<Products />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/Careers" element={<Careers />} />
      <Route path="/solutions/semiconductor" element={<Semiconductor />} />
      <Route path="/solutions/battery" element={<Battery />} />
      <Route path="/solutions/automobiles" element={<AutomobilesAndParts />} />
      <Route path="/solutions/foodanddrink" element={<FoodAndDrink />} />
      <Route path="/solutions/port" element={<Port />} />
      <Route path="/solutions/print" element={<Print />} />
      <Route path="/solutions/Packaging" element={<Packaging />} />
      <Route path="/solutions/RubberAndPlastic" element={<RubberAndPlastic />} />
      <Route path="/products/InductiveSensor" element={<InductiveSensor />} />
      <Route path="/products/PhotoelectricSensors" element={<PhotoelectricSensors />} />
      <Route path="/products/CapacitiveSensor" element={<CapacitiveSensor />} />
      <Route path="/products/MagneticSensor" element={<MagneticSensor />} />
      <Route path="/products/UltrasonicSensor" element={<UltrasonicSensor />} />
      <Route path="/products/ColorMarkDetection" element={<ColorMarkDetection />} />
      <Route path="/products/VisionSensor" element={<VisionSensor />} />
      <Route path="/products/CodeReader" element={<CodeReader />} />
      <Route path="/products/AreaObstacleAvoidanceSensor" element={<AreaObstacleAvoidanceSensor />} />
      <Route path="/products/NetworkAndConnection" element={<NetworkAndConnection />} />
      <Route path="/products/PressureVacuumSensor" element={<PressureVacuumSensor />} />
      <Route path="/products/LevelSensor" element={<LevelSensor />} />
      <Route path="/products/FlowSensorsFlowMeters" element={<FlowSensorsFlowMeters />} />
      <Route path="/products/TemperatureSensors" element={<TemperatureSensors />} />
      <Route path="/products/AnalyticalSensors" element={<AnalyticalSensors />} />
      <Route path="/products/BTU_HEAT_Meter" element={<BTU_HEAT_Meter />} />
      <Route path="/Solutions" element={<Solutions />} />
      <Route path="/ProcessDevice" element={<ProcessDevice />} />
      <Route path="/solutions/EnergyIndustry" element={<EnergyIndustry />} />
      <Route path="/solutions/IndustrialRobots" element={<IndustrialRobots />} />
      <Route path="/solutions/ElectronicsIndustry" element={<ElectronicsIndustry />} />
      <Route path="/solutions/LogisticsIndustry" element={<LogisticsIndustry />} />
      <Route path="/solutions/MedicalTechnology" element={<MedicalTechnology />} />
      <Route path="/PositionSensor" element={<PositionSensor />} />
      <Route path="/ProcessFluidSensors" element={<ProcessFluidSensors />} />
      <Route path="/AiImageRecognition" element={<AiImageRecognition />} />
      <Route path="/CodeReaderNew" element={<CodeReaderNew />} />
      <Route path="/SafetySensor" element={<SafetySensor />} />
      <Route path="/TestBox" element={<TestBox />} />
      <Route path="/ChemicalEngineering" element={<ChemicalEngineering />} />
    </Routes>
  );
};


function App() {
  return (
    <Router>
{/* <CustomCursor /> */}
 <FloatingButton />
      <AppRoutes />
 <RouteTitleManager />
    
  </Router>  );
}

export default App;

